import { useCallback, useEffect, useState } from "react";

import { THEMES, type Theme, type ThemeName } from "../themes";

const STORAGE_KEY = "aero.theme.v1";

function load(): ThemeName {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw && raw in THEMES) return raw as ThemeName;
  } catch {
    /* ignore */
  }
  return "cyber";
}

export function useTheme(): {
  theme: Theme;
  name: ThemeName;
  setName: (n: ThemeName) => void;
} {
  const [name, setNameState] = useState<ThemeName>(load);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, name);
    } catch {
      /* ignore */
    }
  }, [name]);

  const setName = useCallback((n: ThemeName) => setNameState(n), []);

  return { theme: THEMES[name], name, setName };
}
